/**
 * V2 Layout Shell — universal wrapper that adds V2PageChrome
 * to any tab when staff_v2_redesign capability is enabled.
 *
 * - Custom v2 pages (v2-*) manage their own chrome — skipped here
 * - Unknown tabs render as-is (no chrome)
 * - Metadata from v2TabMeta.ts drives crumb/title
 */
import V2PageChrome from './V2PageChrome'
import { V2_TAB_META } from './v2TabMeta'

interface V2LayoutShellProps {
  activeTab: string
  isV2Enabled: boolean
  children: React.ReactNode
}

export function V2LayoutShell({ activeTab, isV2Enabled, children }: V2LayoutShellProps) {
  // Not in v2 mode — render children as-is
  if (!isV2Enabled) return <>{children}</>

  // Custom v2 pages manage their own page chrome
  if (activeTab.startsWith('v2-')) return <>{children}</>

  // Look up metadata for this tab
  const meta = V2_TAB_META[activeTab]
  if (!meta) return <>{children}</>

  return (
    <V2PageChrome crumb={meta.crumb} title={meta.title} flush={meta.flush}>
      {children}
    </V2PageChrome>
  )
}

export default V2LayoutShell
